// store/useCabinetStore.ts
import { create } from 'zustand';
import { cabinetInitialState, CabinetState } from './cabinetInitialState';
import { CabinetActions, createCabinetSlice } from './createCabinetSlice';
import { combine, persist } from 'zustand/middleware';

export const useCabinetStore = create<CabinetState & CabinetActions>()(
  persist(combine(cabinetInitialState, createCabinetSlice as any), {
    name: 'cabinet-store',
  }),
);
